import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <TopicsSection />
        <MediaSection />
        <CardsSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}